import React from "react";
import { GetinTouch } from "../../assets/img";
import ChatIcon from "@mui/icons-material/Chat";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

const GetInTouch = () => {
  return (
    <div className="ticket-grid-container1">
      <div className="ticket-card1">

        {/* Left Side Image */}
        <div className="ticket-left1">
          <img src={GetinTouch} className="touch-img" alt="Get in Touch" />
        </div>

        {/* Right Side Content */}
        <div className="ticket-right1">
          <h2>Get in Touch With Our Support Team</h2>
          <p className="sub1">
            Have a question about Book My Rajshree?
          </p>
          <p className="sub1">
            Our friendly support team is ready to help.
          </p>

          {/* Chat Button */}
          <div className="touch-btn1">
            <ChatIcon className="touch-icon1" />
            <button>Chat With Us</button>
          </div>

          {/* Email Button */}
          <div className="touch-btn1">
            <MarkEmailReadIcon className="touch-icon1" />
            <button>Email Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
